import { Box, PlatformDialog } from "@platform/style";
import React from "react";

export function About(props: { open: boolean; onClose: () => void }) {
  return (
    <PlatformDialog open={props.open} title={"About"} onClose={props.onClose}>
      <Box padding={"24px"} alignItems={"center"} textAlign={"center"} color={"text.primary"}>
        <Box>Confidential, Proprietary and/or Trade Secret | TM SM ®</Box>
        <Box component={"span"}>Trademark(s) of © </Box>
        {new Date().getFullYear()}
        <Box>Intercontinental Exchange Inc, or an affiliate.</Box>
        <Box component={"span"}>© {new Date().getFullYear()}</Box>
        <Box component={"span"}>Intercontinental Exchange Inc. All Rights Reserved.</Box>
      </Box>
    </PlatformDialog>
  );
}
